import { useState } from "react";
import clsx from "clsx";
import { choreo, collab, film } from "./constants";
import { Tabs } from "components";

const tabs = [
  { id: "choreography", display: "choreography" },
  { id: "collaborations", display: "collaborations" },
  { id: "film", display: "film" },
];
export default function Anthology() {
  const [selectedTab, setTab] = useState(tabs[0]);

  const tabsProps = {
    tabs,
    selectedTab: selectedTab.id,
    setTab,
    id: "events",
  };

  return (
    <>
      <Tabs {...tabsProps} />
      <div className="flex flex-col justify-center items-center mb-10 lg:my-10">
        <div className={wrapper}>
          {selectedTab.id === tabs[0].id &&
            choreo.map((item) => <ListItem item={item} />)}
          {selectedTab.id === tabs[1].id &&
            collab.map((item) => <ListItem item={item} />)}
          {selectedTab.id === tabs[2].id &&
            film.map((item) => <ListItem item={item} />)}
        </div>
      </div>
    </>
  );
}

function ListItem({ item }) {
  return (
    <div
      key={item.title}
      className="flex flex-col-reverse mt-4 max-w-[300px]"
    >
      <div className="my-4 w-[300px] flex items-start flex-col">
        <div className="font-bold text-sm">{item.title}</div>
        <div className="text-xs">{item.event}</div>
        <div className="text-[10px] mt-2 flex">
          <div className="">
            Date: {item.date} {item.time} | Style: {item.style} | Performer/s:{" "}
            {item.performer} | Location: {item.location} | Music: {item.music} |
            Production: {item.production}
          </div>
        </div>
      </div>
      {item.reel ? (
        <iframe
          src={item.reel}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
          title={item.title + " video"}
          className="h-[200px] rounded-md"
        />
      ) : (
        <div className="w-full bg-black/10 h-[200px] flex justify-center items-center rounded-md">
          <div className="text-black/40 ">coming soon</div>
        </div>
      )}
    </div>
  );
}
const wrapper = clsx("flex flex-wrap w-full justify-around items-start");
